.wrap {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
}
.icon {
  position: absolute;
  inset-inline-start: 12px;
  color: var(--color-text-subtle);
  pointer-events: none;
}
.input {
  width: 100%;
  height: var(--control-h-md);
  padding-inline: 40px;
  background: var(--color-surface);
  border: 1.5px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  color: var(--color-text);
  -webkit-appearance: none;
  appearance: none;
}
.input::-webkit-search-cancel-button {
  display: none;
}
.input::placeholder {
  color: var(--color-text-subtle);
}
.input:focus-visible {
  outline: none;
  border-color: var(--color-accent-ink);
  box-shadow: 0 0 0 3px var(--color-focus);
  border-radius: var(--radius-md);
}
.clear {
  position: absolute;
  inset-inline-end: 8px;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--color-text-subtle);
  cursor: pointer;
}
.clear:hover {
  background: var(--color-neutral-soft);
}
